import { SxProps, Theme } from "@mui/material";
import { allowedTLDs } from "@src/shared/const";
import * as yup from "yup";

const emailTLDCheck = (value: string | null | undefined) => {
  if (!value) {
    return true;
  }

  const domain = value.split("@")[1];
  if (!domain) return false;

  const domainParts = domain.split(".");
  if (domainParts.length !== 2) return false;

  const tld = domainParts[1].toLowerCase();
  return allowedTLDs.includes(tld);
};

export const ITariffTeamFormSchema = yup.object({
  name: yup.string().required("Обязательное поле").min(2, "Минимум 2 символа"),
  phone: yup
    .string()
    .required("Обязательное поле")
    .matches(/^\d{10,15}$/, "Неверный формат номера"),
  email: yup
    .string()
    .required("Обязательное поле")

    .email("Неверный формат email")
    .test("valid-tld", "Недопустимая доменная зона", emailTLDCheck),
  inn: yup.string().required("Обязательное поле"),
});

export const cancelBtnStyles: SxProps<Theme> = {
  padding: "10px 32px",
  borderRadius: "10px",
  color: "white",
  fontWeight: 600,
  transition: "background 0.3s",
  background: "#1FA1E5",
  "&:disabled": {
    background: "#cccccc",
    color: "#666666",
  },
};

export const saveBtnStyles: SxProps<Theme> = {
  padding: "10px 32px",
  borderRadius: "10px",
  color: "white",
  fontWeight: 600,
  transition: "background 0.3s",
  background: "#00C195",
  "&:disabled": {
    background: "#cccccc",
    color: "#666666",
  },
};
